import React, { useState, useEffect } from "react";
import { db } from "../config/firebase"; // Import Firestore configuration
import { collection, getDocs } from "firebase/firestore"; // Import necessary Firestore methods
import BlogCard from "./blogcard"; // Import your BlogCard component

export default function BlogCards() {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const blogs = [];
        const querySnapshot = await getDocs(collection(db, "Blogs"));

        // Log querySnapshot to inspect it
        console.log("querySnapshot", querySnapshot);

        if (querySnapshot.empty) {
          console.log("No matching documents.");
          return;
        }

        querySnapshot.forEach((doc) => {
          blogs.push({ id: doc.id, ...doc.data() });
        });

        console.log("Fetched blogs:", blogs);

        setBlogs(blogs);
      } catch (error) {
        console.log("Error getting blogs:", error);
      }
    };

    fetchBlogs();
  }, []);

  return (
    <div className="Cards">
      <div className="card-container">
        {blogs.length === 0 ? (
          <h2 className="no-blogs">There are no blogs available right now, please check again soon.</h2>
        ) : (
          blogs.map((blog) => (
            <BlogCard key={blog.id} blog={blog} />
          ))
        )}
      </div>
      <style>{`
        .Cards {
          margin: 0;
          padding: 20px 0;
          font-family: sans-serif;
                    background: linear-gradient(135deg, #f9f9f9, #e8e8e8);

        }

        .cards-title {
          text-align: center;
          padding: 20px;
          font-size: 2.5rem;
          font-weight: bold;
        }

        .card-container {
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
          gap: 20px;
        }

        .no-blogs {
          text-align: center;
          padding: 20px;
          font-size: 2rem;
          color: #333;
        }
      `}</style>
    </div>
  );
}
